import { render, staticRenderFns } from "./ModalAlmoxarifadoItemBemConsumo.vue?vue&type=template&id=5778008d"
import script from "./ModalAlmoxarifadoItemBemConsumo.vue?vue&type=script&lang=js"
export * from "./ModalAlmoxarifadoItemBemConsumo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports